<template>
    <dialog-highly
        ref="dialog"
        class="dialog-highly-permission"
        :title="title"
        :desc="desc"
        count-down="10"
        sure-label="立即跳转"
        tips="${countDown} 秒后跳转到用户中心"
        :sure-method="sureMethod"
    ></dialog-highly>
</template>

<script>
import { dateParse } from '@isyscore/utils/date';
import DialogHighly from './dialog-highly';
export default {
    name: 'DialogHighlyPermission',
    components: { DialogHighly },

    props: {
        // 类型，可选：文档/下载
        kind: {
            type: String,
            default: '文档'
        }
    },

    computed: {
        userRole() {
            const { role } = this.$store.state.user.userInfo;

            return role;
        },

        can() {
            const { userRole } = this;

            if (!userRole) return false;

            const { kind } = this;
            const isEnterprise = userRole === 'ENTERPRISE';
            const isPartner = userRole === 'PARTNER';

            if (kind === '文档') return isEnterprise || isPartner;
            if (kind === '下载') return isPartner;

            return false;
        },

        expired() {
            if (!this.can) return false;

            const { expireTime } = this.$store.state.user.userInfo;

            if (expireTime === null) return false;

            const expireDate = dateParse(expireTime);

            return expireDate.getTime() < Date.now();
        },

        title() {
            if (this.expired) return '您的账户授权已过期';

            return {
                文档: '文档中心仅对企业用户开放',
                下载: '下载仅对合作伙伴开放'
            }[this.kind];
        },

        desc() {
            const { userRole } = this;

            if (this.expired) {
                if (userRole === 'PARTNER') return '请联系您的客户经理';
                else return '请在用户中心申请成为合作伙伴';
            }

            return {
                文档: '请在用户中心申请成为企业用户',
                下载: '请在用户中心申请成为合作伙伴'
            }[this.kind];
        }
    },

    mounted() {
        if (this.can && !this.expired) return;

        this.$refs.dialog.open();
    },

    methods: {
        sureMethod() {
            this.$router.push({ name: '用户中心', query: { tab: 'accountAuth' } });
        }
    }
};
</script>

<style lang="scss" scoped></style>
